import { jsxs as r, jsx as i } from "react/jsx-runtime";
import { useTranslation as d } from "react-i18next";
import p from "classnames";
import m from "../../../components/Button/index.js";
import g from "../../../icons/Plus.js";
import z from "../../../icons/Trash.js";
const v = "forma-ui__file-dropzone-files-grid__files", b = "forma-ui__file-dropzone-files-grid__columns-1", N = "forma-ui__file-dropzone-files-grid__columns-2", y = "forma-ui__file-dropzone-files-grid__columns-3", x = "forma-ui__file-dropzone-files-grid__columns-4", I = "forma-ui__file-dropzone-files-grid__columns-5", h = "forma-ui__file-dropzone-files-grid__columns-6", k = "forma-ui__file-dropzone-files-grid__file", C = "forma-ui__file-dropzone-files-grid__image", j = "forma-ui__file-dropzone-files-grid__remove", w = "forma-ui__file-dropzone-files-grid__overlay", F = "forma-ui__file-dropzone-files-grid__button", L = "forma-ui__file-dropzone-files-grid__buttonIcon", o = {
  files: v,
  "columns-1": "forma-ui__file-dropzone-files-grid__columns-1",
  columns1: b,
  "columns-2": "forma-ui__file-dropzone-files-grid__columns-2",
  columns2: N,
  "columns-3": "forma-ui__file-dropzone-files-grid__columns-3",
  columns3: y,
  "columns-4": "forma-ui__file-dropzone-files-grid__columns-4",
  columns4: x,
  "columns-5": "forma-ui__file-dropzone-files-grid__columns-5",
  columns5: I,
  "columns-6": "forma-ui__file-dropzone-files-grid__columns-6",
  columns6: h,
  file: k,
  image: C,
  remove: j,
  overlay: w,
  button: F,
  buttonIcon: L
}, B = ({ files: l, onRemove: _, columns: c, onClickAdd: t, maxFiles: f }) => {
  const { t: s } = d();
  return /* @__PURE__ */ r("div", { className: p(o.files, o[`columns-${c}`]), children: [
    l.map((e, u) => {
      const a = e.name.lastIndexOf("."), n = e.name.slice(0, a);
      return /* @__PURE__ */ r("div", { className: o.file, children: [
        /* @__PURE__ */ i("img", { src: URL.createObjectURL(e), className: o.image, alt: n, title: n }),
        /* @__PURE__ */ i("div", { className: o.overlay }),
        /* @__PURE__ */ i(
          m,
          {
            className: o.remove,
            viewStyle: "text",
            iconClassName: o.removeIcon,
            icon: /* @__PURE__ */ i(z, {}),
            onClick: () => _(u),
            title: s("uikit:delete")
          }
        )
      ] }, e.path);
    }),
    l.length < f && /* @__PURE__ */ i(
      m,
      {
        className: o.button,
        viewStyle: "secondary",
        size: "small",
        onClick: (e) => {
          e.stopPropagation(), t();
        },
        title: s("uikit:upload"),
        iconClassName: o.buttonIcon,
        icon: /* @__PURE__ */ i(g, {})
      }
    )
  ] });
};
export {
  B as default
};
